export class Count {
    noOfCorrectAnswers : number;
    noOfQuestions : number;
    noOfWrongAnswers : number;
    clientStatus : string;
    partNumber : number;
    marks : number;
    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}


// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/model/count.ts